/**
 * @generated SignedSource<<e10dff86706247b097c9cd0cebfa06c8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespIconBubblesWrapper_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespIconBubbles_user">;
  readonly " $fragmentType": "PdpRespIconBubblesWrapper_user";
};
export type PdpRespIconBubblesWrapper_user$key = {
  readonly " $data"?: PdpRespIconBubblesWrapper_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespIconBubblesWrapper_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespIconBubblesWrapper_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespIconBubbles_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "00c6226b340b52fb957daa7991daa63c";

export default node;
